import {
  useState,
  forwardRef,
  Ref,
  useImperativeHandle,
  useRef,
  useEffect,
} from "react";
import { Switch } from "@headlessui/react";
import { logger } from "src/lib/utils";
export interface SwitchElement {
  isChecked: () => void;
}

const ToggleSwitch = forwardRef(
  (
    props: { type: string; value: boolean; onValueChanged: any, disabled?: boolean },
    ref: Ref<SwitchElement>
  ) => {
    const [toggled, setToggled] = useState(props.value);

    function isChecked() {
      return toggled;
    }

    useImperativeHandle(ref, () => ({ isChecked }));

    useEffect(() => {
      setToggled(props.value);
    }, [props.value]);

    return (
      <Switch
        checked={toggled}
        disabled={props.disabled}
        onChange={(checked) => {
          //setToggled(checked);
          props.onValueChanged(props.type, checked);
        }}
        className={`${toggled ? "bg-[#34C759]" : "bg-secondary"
          } relative inline-flex h-5 w-8 items-center rounded-full flex-shrink-0 ${props.disabled ? "opacity-90 cursor-not-allowed" : ""
          }`}
      >
        <span
          className={`${toggled ? "translate-x-4" : "translate-x-1"
            } inline-block h-3 w-3 transform rounded-full bg-white transition`}
        />
      </Switch>
    );
  }
);
ToggleSwitch.displayName = "ToggleSwitch";

export default ToggleSwitch;
